<template>
  <v-data-table
  :headers="headers"
  :items="items"
  class="elevation-1"
  fixed-header="true"
  >
  <template  v-slot:item[data.data[0][d]]="{ item }">
    <div v-bind:key="d">{{ d }}</div>
  </template>

  </v-data-table>
</template>

<script>

export default {
  name: 'DataTable',
  props: {
    headers: {
      type: Array
    },
    items: {
      type: Array
    },
    text: {
      type: String
    }
  },
  data () {
    return {
      metroMap: null
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
